import { z } from 'zod';
export const reportingRangeReason = z.enum([
    'default_from',
    'default_to',
    'invalid_from',
    'invalid_to',
    'reversed',
    'from_after_complete_through',
    'to_after_complete_through',
    'max_days',
]);
export const completeReportingRange = z.object({
    requested: z.object({
        from: z.string().nullable(),
        to: z.string().nullable(),
    }),
    effective: z.object({
        from: z.string(),
        to: z.string(),
        completeDays: z.number().int().positive(),
    }),
    completeThrough: z.string(),
    reasonCodes: z.array(reportingRangeReason),
});
//# sourceMappingURL=reporting.js.map